import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { HealthFaqItem } from "./HealthFaqItem";
import { HealthSection } from "./HealthSection";
import { getLocalized, HealthLang } from "./healthTypes";
import { HealthSectionHeader } from "./HealthSectionHeader";
import { HEALTH_BG_LIFECYCLE } from "./healthVisualStyles";

interface HealthFaqSectionProps {
    data: DataKeys;
}

export function HealthFaqSection({ data }: HealthFaqSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const items: DataKeys[] = data?.items ?? [];
    const sectionId = "faq";
    const eyebrow = getLocalized(data?.eyebrow, hLang);
    const title = getLocalized(data?.title, hLang);
    const subtitle = getLocalized(data?.subtitle, hLang);

    return (
        <HealthSection
            id={sectionId}
            ariaLabelledBy={`${sectionId}-title`}
            compact
            style={{ backgroundColor: HEALTH_BG_LIFECYCLE }}
        >
            <HealthSectionHeader
                title={title}
                titleId={`${sectionId}-title`}
                eyebrow={eyebrow}
                subtitle={subtitle}
            />
            <div className="w-full min-w-0">
                {items.map((item, index) => (
                    <HealthFaqItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                        lang={hLang}
                    />
                ))}
            </div>
        </HealthSection>
    );
}
